import { Injectable, EventEmitter } from '@angular/core';

interface featureOperations {
  component: string, // topic or subFeature or featureDetail
  operation: string, // copy or delete or close
  data: any 
};

@Injectable()
export class OntologyTreeService {

  canViewAnalytics = false;
  private selectedNode = null;

  ontologyNodeSelectEvent: EventEmitter<Object> = new EventEmitter();
  ontologyNodeReloadEvent: EventEmitter<Boolean> = new EventEmitter();
  ontologyNodeFeatureEvent: EventEmitter<Object> = new EventEmitter();
  ontologyHideLoaderEvent: EventEmitter<Boolean> = new EventEmitter();
  ontologyNodeCopied: EventEmitter<String> = new EventEmitter();

  featureDetailEvent: EventEmitter<any> = new EventEmitter();
  featureCreateEvent: EventEmitter<any> = new EventEmitter();
  featureContentEvent: EventEmitter<any> = new EventEmitter();

  subFeatureCreateEvent: EventEmitter<any> = new EventEmitter();
  subFeatureEvent: EventEmitter<any> = new EventEmitter();
  subFeatureSave: EventEmitter<any> = new EventEmitter();
  subFeatureContentEvent: EventEmitter<any> = new EventEmitter();

  featureOperationsEvent: EventEmitter<featureOperations> = new EventEmitter();

  LoaderFlagSetEvent: EventEmitter<boolean> = new EventEmitter();

  contentPreviewEvent: EventEmitter<any> = new EventEmitter();
  contentPreviewCloseEvent: EventEmitter<any> = new EventEmitter();
  previewLiveEvent: EventEmitter<any> = new EventEmitter();

  topicAddedEvent: EventEmitter<any> = new EventEmitter();

  subTopicEvent: EventEmitter<any> = new EventEmitter();
  tabChangeEvent:  EventEmitter<any> = new EventEmitter();

  constructor() {
    this.ontologyNodeSelectEvent.subscribe(node => {
      this.selectedNode = node;
    });

    this.ontologyNodeReloadEvent.subscribe(data => {
      if (!data) {
        this.selectedNode = null;
      }
    });
  }

  public getSelectedNode() {
    if (this.selectedNode) {
      return this.selectedNode;
    }
    return false;
  }


}
